import { EditorProvider } from "@tiptap/react";
import React, { useState } from "react";
import { MenuBar, extensions, props } from "../../components/Markdown/Markdown";

const MarkdownEditor = ({
  descriptionContent,
  setDescriptionContent,
  intial,
  setInitial,
}) => {
  // Provide default values for missing props to prevent crashes
  const [localInitial, setLocalInitial] = useState(false);
  
  // Use provided setInitial if available, otherwise use local state
  const handleSetInitial = setInitial || setLocalInitial;
  const initialValue = intial !== undefined ? intial : localInitial;

  return (
    <div>
      <div className="min-h-96 my-4 border-[2px] rounded-lg">
        <EditorProvider
          placeholder="Enter your description"
          editorProps={props}
          slotBefore={
            <MenuBar
              descriptionContent={descriptionContent}
              setDescriptionContent={setDescriptionContent}
              initial={initialValue}
              setInitial={handleSetInitial}
            />
          }
          extensions={extensions}
          content={descriptionContent}
        ></EditorProvider>
      </div>
    </div>
  );
};

export default MarkdownEditor;
